import React from 'react';
import { HowItWorksProps } from './HowItWorksSection/HowItWorksSection';
import { DetailsProps } from './DetailsSection/DetailsSection';
import { FeatureComparison } from './BundleFeatureComparisonSection/BundleFeatureComparisonSection';
import { Question } from './SupportSection/FAQSection';
import { Props as BlogPostProps } from '../../../shared/components/BlogPost/BlogPost';

export interface CategoryHeroConfig {
    titlePrefix: string;
    title: string;
    description: string;
    headingGradient: string[];
    interaction: InteractionProps;
    heroImage?: any;
    images: Image[];
}

export interface InteractionProps {
    link: string;
    buttonColor: string;
    buttonText: string;
}

export type Image = {
    src: string;
    designer: string;
    title: string;
};

export type CategoryConfig = {
    key: string;
    title: string;
    pageTitle: string;
    description: string;
    productName: string;
    productSchema: ProductSchema;
    hero: CategoryHeroConfig;
    howItWorks?: HowItWorksProps;
    details?: DetailsProps;
    bundleFeatureComparison?: BundleFeatureComparisonConfig;
    faq: FAQ;
    blogPosts: BlogPostProps[];
};

interface ProductSchema {
    name: string;
    description: string;
    ratingValue: string;
    reviewCount: number;
}

interface FAQ {
    description: string;
    faqQuestions: Question[];
}

interface BundleFeatureComparisonConfig {
    title: string;
    description: string;
    bundleIds: string[];
    featureComparison: FeatureComparison;
}

interface CategoryConfigProviderProps {
    categoryKey: string;
    language: string;
    render(category: CategoryConfig): React.ReactNode;
}

export default function CategoryConfigProvider({
    render,
    categoryKey,
    language,
}: CategoryConfigProviderProps) {
    const categoryConfig = require(`../../content/categories/${categoryKey}.${language}.json`);

    return <>{render(categoryConfig)}</>;
}
